<template>
    <div class="container">
        <div class="logo">

        </div>
        <p class="content" @click="router.push({ path: '/dashboard' })">Mocero Inventory</p>
        <div class="swipe">
            <!-- <p>Slide up</p> -->
        </div>
    </div>
</template>
        
<script lang="ts">
import { defineComponent } from 'vue'
import { RouterLink, RouterView, useRouter } from 'vue-router'

export default defineComponent({

    setup() {
        const router = useRouter()

        return {
            router
        }
    }

})
</script>
        
<style scoped lang="scss">
.container {

    width: 100%;
    height: 100vh;
    background-color: #05096c;


    display: flex;
    align-items: center;
    justify-content: center;


    .content {
        color: white;
        font-size: 34px;
        position: absolute;
        top: 40%;
        text-align: center;
        cursor: pointer;
    }

    .swipe {
        position: absolute;
        bottom: 5px;
        color: white;
        text-align: center;
        // margin-top:80px;
    }
}
</style>